import { formatMessage as coreFormatMessage, } from "@formatjs/intl";
import { isFormatXMLElementFn, } from "intl-messageformat";
import { Children, cloneElement, isValidElement } from "react";
const toKeyedReactNode = (reactNode, key) => isValidElement(reactNode) ? cloneElement(reactNode, { key }) : reactNode;
const assignUniqueKeysToParts = (formatXMLElementFn) => (parts) => formatXMLElementFn(Children.toArray(parts));
const assignUniqueKeysToFormatXMLElementFnArgument = (values) => {
    if (!values) {
        return values;
    }
    return Object.keys(values).reduce((acc, k) => {
        const v = values[k];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[k] = isFormatXMLElementFn(v) ? assignUniqueKeysToParts(v) : v;
        return acc;
    }, {});
};
const formatMessageHof = (config, formatters) => (descriptor, rawValues) => {
    const values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    const chunks = coreFormatMessage(config, formatters, descriptor, values);
    if (Array.isArray(chunks)) {
        return Children.map(chunks, toKeyedReactNode) ?? [];
    }
    return chunks;
};
export { formatMessageHof, assignUniqueKeysToFormatXMLElementFnArgument };
